import { IconButton, SxProps } from '@mui/material'
import { t } from 'i18next'
import { LfCloseIcon } from 'src/components/shared/ui/Icons'
import { theme } from 'src/providers/ThemeProvider'

type Props = {
  onClose: () => void
  styles: SxProps
}

export default function CloseButton(props: Props): JSX.Element {
  const { onClose, styles } = props
  return (
    <IconButton aria-label={t('actions.close')} onClick={onClose} sx={styles}>
      <LfCloseIcon htmlColor={theme.colors.gray02} />
    </IconButton>
  )
}
